<template>
    <VAppLayout>
        <VPageHeader :title="$t('nav.review.title')" />
        <VContainer>
            <VReviewAdd :is-restaurant-logo-visible="false" />
        </VContainer>
    </VAppLayout>
</template>

<script>

import VAppLayout from "@/layouts/VAppLayout.vue";
import VReviewAdd from "@/modules/review/components/VReviewAdd.vue";
import VContainer from "@/components/ui/VContainer.vue";
import VPageHeader from "@/components/ui/VPageHeader.vue";

export default {
    name: "ReviewTab",
    components: {
        VContainer,
        VReviewAdd,
        VAppLayout,
        VPageHeader,
    },
}
</script>

<style lang="scss" scoped>
/* Breathing room between the sticky header and the first question
   ("How would you rate your experience?"). */
::v-deep .v-container {
    padding-top: 18px;
}
</style>
